import React from 'react';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import CAppSubTitle from '../../../app/components/CAppSubTitle';
import { useTranslation } from 'react-i18next';
import IFaqArticle from '../interfaces/IFaqArticle';

type CFaqArticleProps = {
	article: IFaqArticle;
};
const CFaqArticle = (props: CFaqArticleProps) => {
	const { article } = props;
	const { i18n } = useTranslation();
	return (
		<>
			{article && i18n && i18n.language && (article.title as Record<string, string>)[i18n.language] ? (
				<Accordion variant="outlined" sx={{ marginBottom: '15px', '&::before': { height: 0, top: 0 } }}>
					<AccordionSummary expandIcon={<ExpandMoreOutlined />}>
						<CAppSubTitle
							title={(article.title as Record<string, string>)[i18n.language]}
							sx={{ margin: '0px', fontSize: '1.2rem' }}
						/>
					</AccordionSummary>
					<AccordionDetails>
						<Box>{(article.content as Record<string, React.ReactNode>)[i18n.language] ?? ''}</Box>
					</AccordionDetails>
				</Accordion>
			) : (
				''
			)}
		</>
	);
};

export default CFaqArticle;
